import { CheckCircleIcon } from "lucide-react";
import { BrandHeader } from "../SignUp/BrandSignUp";
import { useEffect } from "react";
import mixpanel from "mixpanel-browser";

export const CollabRatingSuccess = () => {
  useEffect(() => {
    mixpanel.track("Collab Rating Success Page Loaded");
  }, []);

  return (
    <>
      <div key="1" className="relative flex flex-col min-h-[100dvh]">
        <div className="sticky top-0 left-0 right-0">
          <BrandHeader />
        </div>
        <div className="flex-1 container px-4 md:px-6 py-12 md:py-24 lg:py-32 bg-white dark:bg-white">
          <div className="size-full flex items-center justify-center">
            <div className="max-w-lg w-full space-y-4">
              <div className="flex flex-col items-center ">
                <CheckCircleIcon className="w-16 h-16 text-green-500" />
                <h1 className="text-3xl font-bold">Feedback Submitted</h1>
                <p className="text-gray-500 dark:text-gray-400">
                  Thank you for your valuable time!
                </p>
              </div>
              <div className="flex flex-col items-center space-y-4">
                <h2 className="text-2xl font-bold">Before you go...</h2>
                <p className="text-gray-500 dark:text-gray-400 text-center">
                  Would you like to explore performance-based influencer
                  marketing?
                  <br />
                  (Only pay for what you get)
                </p>
                <a
                  className="inline-flex h-10 items-center justify-center rounded-md bg-gray-900 px-8 text-sm font-medium text-gray-50 shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-50 dark:text-gray-900 dark:hover:bg-gray-50/90 dark:focus-visible:ring-gray-300"
                  href="https://www.anchors.in/waitlist/?ref=collab_get_verified"
                >
                  Yes, I would
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
